var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "198px",
    height: "188px",
    viewBox: "0 0 198 188",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "star_50") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "parts",
    transform: "translate(-287.000000, -48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "star_50",
    transform: "translate(288.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Star-Copy",
    fill: "#FFD21C",
    points: "98.1132075 140.495552 40.8691554 179.444626 58.7354152 111.885911 4.80200217 68.772642 69.7345836 65.3286185 98.1132075 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-Copy",
    stroke: "#FFD21C",
    strokeWidth: 3.77358491,
    points: "98.1132075 140.495552 40.4437111 178.466543 58.7354152 111.885911 4.80200217 68.772642 73.7763935 65.5945396 98.1132075 0.978082945 122.450022 65.5945396 191.424413 68.772642 137.491 111.885911 155.782704 178.466543"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar50);
export default __webpack_public_path__ + "static/media/star_50.2fdae37385b5d3bc185e3bcde7e6c642.svg";
export { ForwardRef as ReactComponent };